import React, { useState, useEffect } from 'react';
import client from '../api/client';
import InsightCard from './InsightCard';

export default function InsightsPanel() {
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);

  const fetchInsights = () => {
    client.get('/insights')
      .then(res => setInsights(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchInsights(); }, []);

  const handleGenerate = async () => {
    setGenerating(true);
    try {
      const res = await client.post('/insights/generate');
      if (res.data.length === 0) {
        alert('Not enough data yet for insights. Keep logging your check-ins!');
      } else {
        fetchInsights();
      }
    } catch {
      alert('Failed to generate insights. Please try again.');
    } finally {
      setGenerating(false);
    }
  };

  const handleDismiss = async (id) => {
    await client.put(`/insights/${id}/dismiss`);
    setInsights(prev => prev.filter(i => i.id !== id));
  };

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white drop-shadow-sm">AI Insights</h1>
          <p className="text-white/70 mt-1">Pattern analysis from your tracking data</p>
        </div>
        <button
          onClick={handleGenerate}
          disabled={generating}
          className="px-4 py-2 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 disabled:opacity-50"
        >
          {generating ? 'Analyzing...' : 'Generate Insights'}
        </button>
      </div>

      {insights.length === 0 ? (
        <div className="text-center py-16 glass rounded-2xl">
          <p className="text-white/60 text-lg">No insights yet</p>
          <p className="text-white/40 text-sm mt-1">
            Click "Generate Insights" after logging your first check-in
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {insights.map(insight => (
            <InsightCard key={insight.id} insight={insight} onDismiss={handleDismiss} />
          ))}
        </div>
      )}
    </div>
  );
}
